var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeRepeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.266 14.0601C3.11205 15.7706 4.4842 17.1649 6.181 18.0381C7.86564 18.9031 9.78638 19.1952 11.652 18.8701C13.5234 18.5411 15.2379 17.6149 16.539 16.2301C17.8521 14.8323 18.6882 13.054 18.927 11.1511C19.1696 9.24383 18.8043 7.30864 17.883 5.6211C16.9703 3.94642 15.544 2.6091 13.814 1.8061C12.0957 1.01026 10.1646 0.796795 8.314 1.1981C6.464 1.5991 4.948 2.5111 3.694 3.9531C3.543 4.1131 2.959 4.7591 2.474 5.7341M5.5 6.0001L1.891 6.7201L1 3.0001M10 7.0001V11.0001L13 13.0001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeRepeat);
export default __webpack_public_path__ + "static/media/timeRepeat.04bab62fd857ff36c0c91aaed655674f.svg";
export { ForwardRef as ReactComponent };